import { render } from "./adopt_agreement.vue?vue&type=template&id=2638451b"
import script from "./adopt_agreement.vue?vue&type=script&lang=js"
export * from "./adopt_agreement.vue?vue&type=script&lang=js"
script.render = render

export default script